<template>
<b-card class="text-center">
  <i class="fa fa-spinner fa-spin fa-4x"></i>
</b-card>
</template>

<script>
export default {
}
</script>
